import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Card, Row, Col, Image} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import {useAbility} from '@casl/react'
import {AbilityContext} from '../../../modules/auth/core/AbilityContext'
import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {TradeProvision} from './core/_models'
import {getAllTradeProvisions} from './core/_requests'
import {ListTradeProvisionsTable} from './components/ListTradeProvisionsTable'

const TradeProvisionsPage: FC<{subject: string}> = ({subject}) => {
  const ability = useAbility(AbilityContext)
  const axiosPrivate = useAxiosPrivate()
  const [isLoading, setIsLoading] = useState(true)
  const [listTradeProvisions, setListTradeProvisions] = useState<TradeProvision[] | null>([])

  const fetchTradeProvisions = () => {
    setIsLoading(true)
    getAllTradeProvisions(axiosPrivate)
      .then((res) => {
        setListTradeProvisions(res.data.table_data)
      })
      .catch((e) => {
        console.error('Failed to fetch trade provisions:', e)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    fetchTradeProvisions()
  }, [])

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Home',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
      >
        Trade Provisions
      </PageTitle>

      <div className='TradeProvisionsPage'>
        <Row className='mb-5'>
          <Col>
            <Card className='card-custom card-border'>
              <Card.Body className='d-flex align-items-center'>
                <Image src='/media/tina/img-result-documents.jpg' thumbnail width={110} />
                <div className='ms-5 d-flex flex-column justify-content-center'>
                  <h3 className='text-primary'>Trade Provisions</h3>
                  <div className='text-gray-700'>
                    In this module, you can manage trade provision records.
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className='mb-5'>
          <Col>
            <Card>
              <Card.Header className='card-header-stretch'>
                <Card.Title className='w-100'>
                  <div className='title-container w-100 d-flex justify-content-between align-items-center'>
                    <div className='title d-flex align-items-center'>
                      <span className='fa fa-handshake px-2'></span>
                      <h3 className='text-gray-700'>List Trade Provisions</h3>
                    </div>
                    {ability.can('create', subject) ? (
                      <div className='card-action'>
                        <Link
                          to={'/trade-provisions/add'}
                          className='btn btn-primary d-flex gap-4 align-items-center'
                        >
                          <span className='fa fa-plus'></span>
                          Add
                        </Link>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <ListTradeProvisionsTable
                  subject={subject}
                  onTradeProvisionDelete={(deletedId) => {
                    setListTradeProvisions((prev) =>
                      prev ? prev.filter((item) => item.id !== deletedId) : null
                    )
                  }}
                  rows={listTradeProvisions}
                  isLoading={isLoading}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default TradeProvisionsPage
